import React from "react";
import { Guide } from "../../../types/guide";
import {
    cardStyle,
    infoRowStyle,
    sectionTitleStyle,
    emptyTextStyle,
    mutedTextStyle,
} from "../GuideDetailModal.styles";
import { formatDate } from "../GuideDetailModal.utils";

export function ClientCapacityTab({ guide }: { guide: Guide }) {
    const clientCapacity = guide.onboarding?.clientCapacity;

    if (!clientCapacity) {
        return (
            <div style={cardStyle}>
                <p style={emptyTextStyle}>
                    Client capacity information has not been provided yet.
                </p>
            </div>
        );
    }

    const formatCommitment = (value: string | null | undefined): string => {
        if (!value) return "Not specified";
        if (value.toLowerCase().includes("yes")) return "Yes - Agreed";
        if (value.toLowerCase().includes("no")) return "No - Did not agree";
        return value;
    };

    const formatFeeAcceptance = (value: string | null | undefined): string => {
        if (!value) return "Not specified";
        if (value.toLowerCase().includes("yes") || value.toLowerCase().includes("accept")) {
            return "Accepted";
        }
        if (value.toLowerCase().includes("clarification")) {
            return "Needs clarification";
        }
        return value;
    };

    return (
        <>
            <div style={cardStyle}>
                <div style={sectionTitleStyle}>Consultation Availability</div>
                <div style={{ display: "grid", gap: 6, fontSize: 13, color: "#2C2731" }}>
                    <div style={infoRowStyle}>
                        <span>Consultations per week</span>
                        <span style={{ fontWeight: 500 }}>
                            {clientCapacity.consultationsPerWeek || "Not specified"}
                        </span>
                    </div>
                    <div style={infoRowStyle}>
                        <span>New clients per month</span>
                        <span style={{ fontWeight: 500 }}>
                            {clientCapacity.newClientsPerMonth || "Not specified"}
                        </span>
                    </div>
                </div>
            </div>

            <div style={cardStyle}>
                <div style={sectionTitleStyle}>Platform Commitments</div>
                <div style={{ display: "grid", gap: 6, fontSize: 13, color: "#2C2731" }}>
                    <div style={infoRowStyle}>
                        <span>Platform commitment</span>
                        <span
                            style={{
                                fontWeight: 500,
                                color: clientCapacity.platformCommitment?.toLowerCase().includes("yes")
                                    ? "#059669"
                                    : clientCapacity.platformCommitment?.toLowerCase().includes("no")
                                    ? "#dc2626"
                                    : "#2C2731",
                            }}
                        >
                            {formatCommitment(clientCapacity.platformCommitment)}
                        </span>
                    </div>
                    <div style={infoRowStyle}>
                        <span>15% service fee acceptance</span>
                        <span
                            style={{
                                fontWeight: 500,
                                color: clientCapacity.serviceFeeAcceptance?.toLowerCase().includes("yes") ||
                                    clientCapacity.serviceFeeAcceptance?.toLowerCase().includes("accept")
                                    ? "#059669"
                                    : clientCapacity.serviceFeeAcceptance?.toLowerCase().includes("clarification")
                                    ? "#d97706"
                                    : "#2C2731",
                            }}
                        >
                            {formatFeeAcceptance(clientCapacity.serviceFeeAcceptance)}
                        </span>
                    </div>
                </div>
            </div>

            {(clientCapacity.createdAt || clientCapacity.updatedAt) && (
                <div style={{ ...mutedTextStyle, marginTop: 8 }}>
                    {clientCapacity.updatedAt
                        ? `Last updated ${formatDate(clientCapacity.updatedAt)}`
                        : clientCapacity.createdAt
                        ? `Created ${formatDate(clientCapacity.createdAt)}`
                        : null}
                </div>
            )}
        </>
    );
}
